import { setData } from '@/shared/api/user';

export const setDataHandler = (value: any, data: { playdeck: any }) => {
  const resolvedKey = value?.key ?? data['playdeck']?.key;
  const resolvedData = value?.data ?? value;

  setData(resolvedKey, resolvedData);
};
